<template>
  <div class="reseller-transfer-page">
    <div class="rtp-header-spacer" aria-hidden="true"></div>
    <div class="rtp-header-fixed">
      <div class="rtp-header-inner">
        <img
          class="rtp-back"
          src="../../assets/withdrawal_v2/back2.png"
          alt=""
          @click="goBack"
        />
        <p class="rtp-title">{{ $t("guild_transfer_to_reseller") }}</p>
      </div>
    </div>

    <ResellerTransferPanel />
  </div>
</template>

<script>
/**
 * 转移给 Reseller 页 v2 壳层（2026-06-08）
 * 业务逻辑见 reseller-transfer-panel.vue
 */
import ResellerTransferPanel from "@/components/withdrawal/reseller-transfer-panel.vue";

export default {
  name: "toReseller",
  components: { ResellerTransferPanel },
  // 初始化：向原生环境注册 getUserInfo 回调并设置标题
  created() {
    try {
      // 向原生环境注册回调：暴露 getUserInfo 供 webview 注入用户信息
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window["getUserInfo"] = this.getUserInfo;
    } catch (e) {
      /* 浏览器调试 */
    }
    document.title = this.$t("guild_transfer_to_reseller");
  },
  methods: {
    // 原生注入用户信息：解析后写入 localStorage
    getUserInfo(data) {
      const userInfo = JSON.parse(data);
      localStorage.setItem("data", JSON.stringify(userInfo));
    },
    // 返回：无上一页时关闭 webview，否则路由返回
    goBack() {
      if (window.history.length <= 1) {
        this.$completes.complete("getPreviousPage");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style scoped>
.reseller-transfer-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  background: #f5f6f8;
  font-family: "Mada", sans-serif;
}

.reseller-transfer-page >>> .rtp-panel {
  flex: 1;
  min-height: 0;
}

.rtp-header-spacer {
  flex-shrink: 0;
  height: calc(88px + env(safe-area-inset-top));
  height: calc(88px + constant(safe-area-inset-top));
}

.rtp-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding-top: env(safe-area-inset-top);
  background: #f5f6f8;
}

.rtp-header-inner {
  position: relative;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rtp-back {
  position: absolute;
  left: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  height: 64px;
}

.rtp-title {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  color: #000;
}

html[lang="ar"] .reseller-transfer-page {
  direction: rtl;
}

html[lang="ar"] .rtp-back {
  left: auto;
  right: 28px;
  transform: translateY(-50%) rotateY(180deg);
}
</style>
